<div class="flex flex-col items-center gap-[10px] justify-center h-full bg-black">
  <div class="flex flex-col items-center gap-[10px] w-[400px] sm:w-[510px] h-auto sm:h-[453px] max-w-[800px] px-4">
    <img src="/png/Clip path group.svg" alt="Submitted Successfully"
      class="w-[110px] h-[110px] sm:w-[200px] sm:h-[200px]" style="clip-path: inset(0 0 0 0);" />
    <h3 class="self-stretch text-center text-[#F5375C] font-[manrope] 
                text-[20px] sm:text-[28px] not-italic font-extrabold 
                leading-normal tracking-[-0.56px]">
      {{'Submitted Successfully!' |translate}}
    </h3>

    <p class="w-[90%] sm:w-full mx-auto text-center text-white font-[manrope] 
                text-[16px] sm:text-[16px] not-italic font-normal leading-normal">
      {{'Thank you for your interest in our product! Your registration details have been saved.
      Specialists will contact you shortly to provide consultation.'|translate}}
    </p>
  </div>
  <div class="flex flex-col gap-4 w-[200px]">
    <!-- Home Button -->
    <button (click)="goToHome()" [disabled]="isLoading"
      class="w-full rounded bg-[#444444] text-[#F5375C] font-medium py-3 text-center flex justify-center items-center gap-2 transition-all duration-300">
      <ng-container *ngIf="!isLoading; else loadingHome">
        {{ 'home' | translate }}
      </ng-container>

      <ng-template #loadingHome>
        <span class="flex items-center gap-2">
          <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none"
            viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
          </svg>
          {{ 'Loading...' | translate }}
        </span>
      </ng-template>
    </button>

    <!-- Explore More Button -->
    <button (click)="goToExplore()" [disabled]="isLoadingExplore"
      class="w-full rounded bg-[#F5375C] text-white font-medium py-3 text-center flex justify-center items-center gap-2 transition-all duration-300">
      <ng-container *ngIf="!isLoadingExplore; else loadingExplore">
        {{ 'Explore More' | translate }}
      </ng-container>

      <ng-template #loadingExplore>
        <span class="flex items-center gap-2">
          <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none"
            viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
          </svg>
          {{ 'Loading...' | translate }}
        </span>
      </ng-template>
    </button>

  </div>
</div>